'use client'

// import { DocumentIcon } from '@repo/ui/DocumentIcon'
// import { FolderIcon } from '@repo/ui/FolderIcon'
// import MUICheckbox from '@mui/material/Checkbox'
// import MUIPopover from '@mui/material/Popover'
import { AddAttachmentIcon } from '@repo/ui/AddAttachmentIcon'
import { AddPackageLinkIcon } from '@repo/ui/AddPackageLinkIcon'
import { AddPDFAttachmentIcon } from '@repo/ui/AddPDFAttachmentIcon'
import { dateIsInThePast } from '@repo/utils/time'
import { DOCIcon } from '@repo/ui/DOCIcon'
import { FileIcon } from '@repo/ui/FileIcon'
import { formatBytes } from '@repo/utils/numbers'
import { formatDate } from '@repo/utils/time'
import { HoverActionsPill } from '@repo/ui/HoverActionsPill'
import { JPEGIcon } from '@repo/ui/JPEGIcon'
import { LoadingState } from '@repo/ui/LoadingState'
import { MP4Icon } from '@repo/ui/MP4Icon'
import { MSGIcon } from '@repo/ui/MSGIcon'
import { OtherIcon } from '@repo/ui/OtherIcon'
import { PDFIcon } from '@repo/ui/PDFIcon'
import { PPTIcon } from '@repo/ui/PPTIcon'
import { useDebounce } from '@uidotdev/usehooks'
import { useEffect, useRef, useState } from 'react'
import { useEmailCardStore } from '@repo/store/useEmailCardStore'
import { XLSIcon } from '@repo/ui/XLSIcon'
import { ZIPIcon } from '@repo/ui/ZIPIcon'
import MUIBadge from '@mui/material/Badge'
import MUIButton from '@mui/material/Button'
import MUIInput from '@mui/material/Input'
import MUIStack from '@mui/material/Stack'
import MUITab from '@mui/material/Tab'
import MUITabs from '@mui/material/Tabs'
import MUITooltip from '@mui/material/Tooltip'
import MUITypography from '@mui/material/Typography'
import styles from './EmailSidebarAttachmentsPackagesCard.module.scss'

// only allow the user to select items smaller than the following size
const FILE_SIZE_LIMIT = 25000

export const EmailSidebarAttachmentsPackagesCard = ({ testData = false }) => {
  const [extensionFilter, setExtensionFilter] = useState<string[] | null>(null)
  const [files, setFiles] = useState<any[]>([])
  // const [fileTypeAnchorEl, setFileTypeAnchorEl] = useState<null | HTMLElement>(null)
  const [loading, setLoading] = useState(false)
  // const [matterHistoryAnchorEl, setMatterHistoryAnchorEl] = useState<null | HTMLElement>(null)
  const [pageSize] = useState(25)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedFolderIds, setSelectedFolderIds] = useState<number[] | null>(null)
  const [selectedValue, setSelectedValue] = useState<'attachments' | 'packages'>('attachments')
  const [startAtIndex, setStartAtIndex] = useState(0)
  const [totalRowCount, setTotalRowCount] = useState(0)

  const debouncedSearchTerm = useDebounce(searchTerm, 500)
  const debouncedStartAtIndex = useDebounce(startAtIndex, 500)

  const hasTriggeredFetchRef = useRef<boolean>(false)
  const isFetchingRef = useRef<boolean>(false)
  const listRef = useRef<HTMLDivElement | null>(null)
  const searchInputRef = useRef<HTMLInputElement | null>(null)

  const {
    // allMatterHistoryFolderIds,
    fetchAllMatterHistoryFolderIds,
    fetchAttachments,
    fetchPackages,
    toggleSetAttachedAttachments,
    toggleSetAttachedPackages,
    cardExpanded,
    emailSendingCurrentMatterData
  } = useEmailCardStore()
  const { clientMatterNo } = emailSendingCurrentMatterData || {}

  // const openFileTypePopover = Boolean(fileTypeAnchorEl)
  // const openMatterHistoryPopover = Boolean(matterHistoryAnchorEl)

  // const closeFileTypePopover = () => setFileTypeAnchorEl(null)
  // const closeMatterHistoryPopover = () => setMatterHistoryAnchorEl(null)

  // const isExtSelected = (ext: string) => !!extensionFilter?.includes(ext)
  // const toggleExtension = (ext: string) => {
  //   setExtensionFilter((prev) => {
  //     if (!prev || prev.length === 0) return [ext]
  //     const next = prev.includes(ext) ? prev.filter((e) => e !== ext) : [...prev, ext]
  //     return next.length ? next : null
  //   })
  // }
  // const clearExtensions = () => setExtensionFilter(null)

  // const isFolderSelected = (id: number) => !!selectedFolderIds?.includes(id)
  // const toggleFolder = (id: number) => {
  //   setSelectedFolderIds((prev) => {
  //     if (!prev || prev.length === 0) return [id]
  //     const next = prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id]
  //     return next.length ? next : null
  //   })
  // }
  // const clearFolders = () => setSelectedFolderIds(null)

  useEffect(() => {
    const fetchData = async () => {
      if (selectedValue === 'attachments') {
        if (isFetchingRef.current && debouncedStartAtIndex > 0) return
        try {
          setLoading(true)
          isFetchingRef.current = true

          const prevRows = files.length > 0 ? files : []

          const res = await fetchAttachments({
            clientMatterNo,
            startAtIndex: debouncedStartAtIndex,
            searchTerm: debouncedSearchTerm,
            pageSize
          } as any)

          if (debouncedStartAtIndex > 0) {
            setFiles((prev) => [...prevRows, ...(res?.rows || [])])
          } else {
            setFiles(res?.rows || [])
          }

          setTotalRowCount(res?.totalRowCount || 0)
        } catch (err) {
          console.error('Error fetching attachments:', err)
          setTotalRowCount(0)
        } finally {
          setLoading(false)
          isFetchingRef.current = false
        }
      } else if (selectedValue === 'packages') {
        try {
          setLoading(true)
          isFetchingRef.current = true
          const res = await fetchPackages({ clientMatterNo } as any)

          setFiles(res)
          setTotalRowCount(res?.totalRowCount ?? res?.length ?? 0)
        } catch (err) {
          console.error('Error fetching packages:', err)
          setTotalRowCount(0)
        } finally {
          setLoading(false)
          isFetchingRef.current = false
        }
      }
    }

    fetchData()
  }, [
    selectedValue,
    debouncedSearchTerm,
    debouncedStartAtIndex,
    clientMatterNo,
    extensionFilter,
    selectedFolderIds,
    fetchAllMatterHistoryFolderIds,
    fetchAttachments,
    fetchPackages,
    pageSize,
    testData
  ])

  useEffect(() => {
    // reset the start index when the panel opens
    if (cardExpanded === 'attachmentsPackages') {
      setStartAtIndex(0)
    }
  }, [cardExpanded])

  useEffect(() => {
    // reset when the matter changes
    setStartAtIndex(0)
    setTotalRowCount(0)
    setFiles([])
  }, [clientMatterNo])

  const handleSearch = async () => {
    if (testData) return
    if (!searchTerm) return

    if (selectedValue === 'attachments') {
      try {
        setLoading(true)
        setStartAtIndex(0)
        listRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
        const res = await fetchAttachments({
          recipientType: selectedValue,
          searchTerm: debouncedSearchTerm,
          startAtIndex: debouncedStartAtIndex,
          pageSize: pageSize
        } as any)
        setTotalRowCount(res.totalRowCount)
      } catch (err) {
        console.error('Error fetching recipient search results:', err)
        setTotalRowCount(0)
      } finally {
        setLoading(false)
      }
    }
  }

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const el = e.currentTarget
    const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1

    if (isAtBottom) {
      if (!hasTriggeredFetchRef.current && files.length < totalRowCount && !loading && !isFetchingRef.current) {
        hasTriggeredFetchRef.current = true
        setStartAtIndex((prev) => prev + pageSize)
      }
    } else {
      hasTriggeredFetchRef.current = false
    }
  }

  const renderIcon = (fileExtension: string) => {
    const sx = { height: '32px', width: '32px', mr: 1 }

    switch (fileExtension) {
      case 'doc':
      case 'docx':
      case 'txt':
      case 'rtf':
        return <DOCIcon sx={sx} />
      case 'jpg':
      case 'jpeg':
      case 'png':
      case 'gif':
      case 'tif':
      case 'tiff':
      case 'bmp':
      case 'webp':
      case 'heic':
      case 'heif':
      case 'heif-sequence':
      case 'heic-sequence':
        return <JPEGIcon sx={sx} />
      case 'xls':
      case 'xlsx':
      case 'csv':
        return <XLSIcon sx={sx} />
      case 'ppt':
      case 'pptx':
        return <PPTIcon sx={sx} />
      case 'avi':
      case 'm4v':
      case 'mov':
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'webm':
      case 'wmv':
        return <MP4Icon sx={sx} />
      case 'msg':
        return <MSGIcon sx={sx} />
      case 'pdf':
        return <PDFIcon sx={sx} />
      case 'zip':
        return <ZIPIcon sx={sx} />
      default:
        return <OtherIcon sx={sx} />
    }
  }

  return (
    <MUIStack direction="column" spacing={2} sx={{ pb: 4 }} data-testid="EMailSidebarAttachmentsPackagesCard">
      <MUIStack direction="row" spacing={1} sx={{ mb: 2 }}>
        <MUIInput
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value)
            handleSearch()
          }}
          disabled={selectedValue !== 'attachments' || testData}
          onKeyUp={(e) => e.key === 'Enter' && handleSearch()}
          inputProps={{ ref: searchInputRef, maxLength: 80 }}
          sx={{
            width: '100%',
            input: {
              backgroundColor: 'background.dark',
              height: '40px',
              padding: '0 0 0 14px',
              borderRadius: '6px'
            },
            '&:before, &:after': { content: 'none' }
          }}
        />
        {/* <MUIButton
          sx={{ minWidth: '3rem', width: '24px', ml: '8px !important' }}
          onClick={(e) => setFileTypeAnchorEl(e.currentTarget)}
        >
          <MUIBadge color="primary" overlap="circular" badgeContent={extensionFilter?.length || null}>
            <DocumentIcon sx={{ height: '24px', width: '20px' }} />
          </MUIBadge>
        </MUIButton>
        <MUIButton
          sx={{ minWidth: '3rem', width: '24px', mr: '-4px !important' }}
          onClick={(e) => setMatterHistoryAnchorEl(e.currentTarget)}
        >
          <MUIBadge color="primary" overlap="circular" badgeContent={selectedFolderIds?.length || null}>
            <FolderIcon sx={{ height: '24px', width: '24px' }} />
          </MUIBadge>
        </MUIButton> */}
      </MUIStack>

      <MUITabs
        variant="scrollable"
        scrollButtons="auto"
        value={selectedValue}
        onChange={(_: any, v: any) => {
          setSelectedValue(v)
          setFiles([])
          setStartAtIndex(0)
          listRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
        }}
        className={styles.emailSidebarAttachmentsPackagesCardTabs}
        sx={{
          border: 'none',
          overflow: 'visible',
          minHeight: '28px',
          pt: 2,
          pl: 0,
          ['& .MuiTabs-scroller']: { overflow: 'visible' }
        }}
      >
        {(['attachments', 'packages'] as const).map((type) => (
          <MUITab
            key={type}
            value={type}
            label={<MUIBadge>{type[0].toUpperCase() + type.slice(1)}</MUIBadge>}
            className={styles.emailSidebarAttachmentsPackagesCardTab}
            sx={{ overflow: 'visible', ml: '0 !important', mr: '8px !important' }}
          />
        ))}
      </MUITabs>

      <MUIStack
        direction="column"
        spacing={4}
        ref={listRef}
        sx={{ maxHeight: '300px', minHeight: '18.75rem', overflowY: 'auto', pr: 1, pt: 4 }}
        onScroll={handleScroll}
      >
        {files && files.length > 0
          ? (files ?? [])
              .slice()
              // .sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime())
              .map((file: any) => {
                const fileIsTooLarge = selectedValue === 'attachments' && file.size > FILE_SIZE_LIMIT
                const fileIsExpired =
                  selectedValue === 'packages' && file.expiryDate && dateIsInThePast(file.expiryDate)
                const fileIsDisabled = fileIsTooLarge || fileIsExpired

                return (
                  <MUIStack
                    key={
                      selectedValue === 'attachments'
                        ? file.matterHistoryContentId
                        : (file.matterHistoryPackageId ?? file.id ?? `${file.filename}-${file.createdDate}`)
                    }
                    display={'flex'}
                    direction="row"
                    spacing={1}
                    alignItems="flex-start"
                    sx={{
                      cursor: 'pointer',
                      width: '100%',
                      maxHeight: '5rem',
                      position: 'relative',
                      '&:hover': { '.hoverActionsPill': { visibility: 'visible', opacity: 1 } }
                    }}
                  >
                    <MUIStack
                      direction="row"
                      sx={{
                        cursor: fileIsDisabled ? 'not-allowed' : 'pointer',
                        overflow: 'hidden',
                        width: '100%',
                        opacity: fileIsDisabled ? 0.5 : 1
                      }}
                    >
                      {renderIcon(file.fileExtension)}

                      <MUIStack
                        direction="column"
                        spacing={0.5}
                        sx={{ cursor: 'pointer', overflow: 'hidden', width: '100%' }}
                      >
                        <MUIStack
                          direction="row"
                          spacing={2}
                          alignItems="flex-start"
                          sx={{ cursor: 'pointer', overflow: 'hidden', width: '100%' }}
                        >
                          <MUITypography
                            variant="body2"
                            sx={{ cursor: 'pointer', textWrap: 'nowrap', textTransform: 'none' }}
                          >
                            {file.filename}
                          </MUITypography>
                        </MUIStack>
                        <MUIStack
                          direction="row"
                          spacing={2}
                          alignItems="flex-start"
                          sx={{ cursor: 'pointer', width: '100%' }}
                        >
                          <MUITypography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              cursor: 'pointer',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {formatBytes(file.size)}
                          </MUITypography>
                          <MUITypography
                            variant="body2"
                            color="text.secondary"
                            sx={{ margin: '0 8px', cursor: 'pointer' }}
                          >
                            |
                          </MUITypography>
                          <MUITypography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              cursor: 'pointer',
                              textTransform: 'none',
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {formatDate(file.createdDate)}
                          </MUITypography>
                        </MUIStack>
                      </MUIStack>
                      <HoverActionsPill top={'0px'} padding={'4px'} height={'38px'}>
                        {(file.fileExtension.toLowerCase() === 'doc' ||
                          file.fileExtension.toLowerCase() === 'docx') && (
                          <MUITooltip title="Add attachment as PDF" arrow placement="top">
                            <MUIButton
                              disabled={fileIsDisabled}
                              onClick={() =>
                                toggleSetAttachedAttachments({
                                  attachment: file,
                                  matterHistoryContentIsConvertWordToPdfs: true
                                })
                              }
                              sx={{ minWidth: '30px', borderRadius: '50%' }}
                            >
                              <AddPDFAttachmentIcon sx={{ height: '20px', width: '20px' }} />
                            </MUIButton>
                          </MUITooltip>
                        )}
                        <MUITooltip
                          title={selectedValue === 'attachments' ? 'Add attachment' : 'Add package link'}
                          arrow
                          placement="top"
                        >
                          <MUIButton
                            disabled={fileIsDisabled}
                            onClick={() => {
                              if (selectedValue === 'attachments') {
                                toggleSetAttachedAttachments({
                                  attachment: file,
                                  matterHistoryContentIsConvertWordToPdfs: false
                                })
                              } else {
                                toggleSetAttachedPackages({ packageItem: file })
                              }
                            }}
                            sx={{ minWidth: '30px', borderRadius: '50%' }}
                          >
                            {selectedValue === 'attachments' ? (
                              <AddAttachmentIcon sx={{ height: '20px', width: '20px' }} />
                            ) : (
                              <AddPackageLinkIcon sx={{ height: '20px', width: '20px' }} />
                            )}
                          </MUIButton>
                        </MUITooltip>
                      </HoverActionsPill>
                    </MUIStack>
                  </MUIStack>
                )
              })
          : null}

        {files && files.length === 0 && !loading ? (
          <MUIStack direction="column" alignItems="center" justifyContent="center" sx={{ py: 4, minHeight: '16rem' }}>
            <FileIcon sx={{ width: '3rem', height: '3rem', mt: 0 }} />
            <MUITypography variant="body1" sx={{ textAlign: 'center', mt: 2 }}>
              No {selectedValue} found.
            </MUITypography>
          </MUIStack>
        ) : null}

        {loading ? (
          <MUIStack
            direction="row"
            justifyContent="center"
            alignItems="center"
            sx={{ height: '100%', width: '100%', minHeight: '16rem' }}
          >
            <LoadingState />
          </MUIStack>
        ) : null}
      </MUIStack>

      {/* <MUIPopover
        open={openFileTypePopover}
        anchorEl={fileTypeAnchorEl}
        onClose={closeFileTypePopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        sx={{ ['& .MuiPaper-root']: { position: 'relative', width: '14rem', p: '0 8px 8px 8px' } }}
      >
        <MUIStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ backgroundColor: '#f5f6f8', position: 'sticky', top: 0, zIndex: 1, p: '1rem 8px' }}
        >
          <MUITypography>File Type</MUITypography>
          <MUIButton size="small" onClick={clearExtensions} sx={{ pt: 0 }}>
            Clear
          </MUIButton>
        </MUIStack>

        <MUIStack direction="column" spacing={1} alignItems={'flex-start'} sx={{ maxHeight: '20rem', pt: 1 }}>
          {(
            [
              { key: 'jpg', label: 'JPG', Icon: JPEGIcon },
              { key: 'png', label: 'PNG', Icon: PNGIcon },
              { key: 'gif', label: 'GIF', Icon: GIFIcon },
              { key: 'ppt', label: 'PPT', Icon: PPTIcon },
              { key: 'doc', label: 'DOC', Icon: DOCIcon },
              { key: 'xls', label: 'XLS', Icon: XLSIcon },
              { key: 'pdf', label: 'PDF', Icon: PDFIcon },
              { key: 'msg', label: 'MSG', Icon: MSGIcon },
              { key: 'mp4', label: 'MP4', Icon: MP4Icon },
              { key: 'ZIP', label: 'ZIP', Icon: ZIPIcon },
              { key: 'Other', label: 'Other', Icon: OtherIcon }
            ] as const
          ).map(({ key, label, Icon }) => (
            <MUIButton
              key={key}
              sx={{ width: '100%', justifyContent: 'flex-start', p: 1 }}
              onClick={() => toggleExtension(key)}
            >
              <MUICheckbox checked={isExtSelected(key)} sx={{ p: 0, mr: 1 }} />
              <Icon sx={{ height: '32px', width: '32px', mr: 1 }} />
              <MUITypography variant="body2" sx={{ textWrapMode: 'nowrap', textAlign: 'left', mb: 0 }}>
                {label}
              </MUITypography>
            </MUIButton>
          ))}
        </MUIStack>
      </MUIPopover>

      <MUIPopover
        open={openMatterHistoryPopover}
        anchorEl={matterHistoryAnchorEl}
        onClose={closeMatterHistoryPopover}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        sx={{ ['& .MuiPaper-root']: { position: 'relative', width: '14rem', p: '0 8px 56px 8px' } }}
      >
        <MUIStack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ backgroundColor: '#f5f6f8', position: 'sticky', top: 0, zIndex: 1, p: '1rem 8px' }}
        >
          <MUITypography>Folders</MUITypography>
          <MUIButton size="small" onClick={clearFolders} sx={{ pt: 0 }}>
            Clear
          </MUIButton>
        </MUIStack>

        <MUIStack direction="column" spacing={1} alignItems={'flex-start'} sx={{ maxHeight: '20rem', pt: 1 }}>
          {allMatterHistoryFolderIds?.length > 0 &&
            allMatterHistoryFolderIds.map((folder: any) => (
              <MUIButton
                key={folder.matterHistoryFolderId}
                sx={{ width: '100%', justifyContent: 'flex-start', p: 1 }}
                onClick={() => toggleFolder(folder.matterHistoryFolderId)}
              >
                <MUICheckbox checked={isFolderSelected(folder.matterHistoryFolderId)} sx={{ p: 0, mr: 1 }} />
                <MUITypography variant="body2" sx={{ textWrapMode: 'nowrap', textAlign: 'left', mb: 0 }}>
                  {folder.name}
                </MUITypography>
              </MUIButton>
            ))}
        </MUIStack>
      </MUIPopover> */}
    </MUIStack>
  )
}
